var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7463 73.7392C107.323 52.5629 100.392 27.5679 81.2769 14.3481C62.1618 1.12824 36.3289 3.46389 19.8949 19.8979C3.46096 36.3319 1.12531 62.1647 14.3452 81.2798C27.565 100.395 52.56 107.326 73.7363 97.7492",
    stroke: "#8DA8FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentro);
export default __webpack_public_path__ + "static/media/dentro.625fad2af8e5384000ed310c823eacc7.svg";
export { ForwardRef as ReactComponent };